// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AavQCwg664BsHWH0sJNMS{margin-bottom:1.6rem}._29tzeXvyXtaHRQDLKBj_3F{display:block;height:20rem!important;width:20rem;margin:0 auto 1.6rem}._1pqAlLBoP6DxLciUr_PuqL{margin-top:2.4rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "AavQCwg664BsHWH0sJNMS",
	"image": "_29tzeXvyXtaHRQDLKBj_3F",
	"error": "_1pqAlLBoP6DxLciUr_PuqL"
};
module.exports = ___CSS_LOADER_EXPORT___;
